import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { ShopSection } from "@/components/ShopSection";
import { usePageView } from "@/hooks/use-page-view";


export const Route = createFileRoute("/shop/")({
  head: () => ({
    meta: [
      { title: "Shop - Digital curiosity packs from Smartasaurus" },
      {
        name: "description",
        content:
          "Instant-download curiosity games from Smartasaurus - Guess Which Fact Is Fake, the Ultimate Trivia Pack and more. Physical editions on the waitlist.",
      },
      { property: "og:title", content: "Smartasaurus Shop - Curiosity, delivered instantly" },
      {
        property: "og:description",
        content:
          "Digital editions you can download and play in 60 seconds. Vote with your email to unlock premium physical editions.",
      },
      { property: "og:url", content: "https://smartasaurus.com/shop" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "Smartasaurus Shop - Curiosity, delivered instantly" },
      { name: "twitter:description", content: "Digital editions you can download and play in 60 seconds." },
    ],
    links: [{ rel: "canonical", href: "https://smartasaurus.com/shop" }],
  }),
  component: ShopPage,
});

function ShopPage() {
  usePageView("shop");
  return (
    <div className="min-h-screen bg-background">

      <SiteHeader />
      <main id="main-content" className="pt-10">
        <ShopSection />
      </main>
      <SiteFooter />
    </div>
  );
}
